import * as yup from 'yup';

import { StringTypeBase } from '../../types/baseTypes/StringTypeBase';
import { TypeContextEnum } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_TEXT } from '../constants';

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use EmailType from application-types instead.
 */
export class EmailType extends StringTypeBase {
  group = TYPE_GROUP_TEXT;

  name = 'Email';

  friendlyName = 'Email';

  contexts = [
    TypeContextEnum.Block,
    TypeContextEnum.Content,
    TypeContextEnum.Data,
    TypeContextEnum.Properties,
  ];

  get example() {
    const examples = [
      'lane.doe@joinlane.com',
      'rmaccio@joinlane.com',
      'example@joinlane.com',
    ];

    return examples[Math.floor(Math.random() * examples.length)];
  }

  get default(): any {
    return '';
  }

  buildSchema() {
    return yup.string().email('Must be a valid email address.').nullable();
  }
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use Email from application-types instead.
 */
const definition = new EmailType();

Types.addBaseType(definition);
export default definition;
